module.exports = __webpack_public_path__ + "static/media/atlanta.77549301.webp";